import * as actionTypes from './actionTypes';

export const toggleTransactionAddModal=()=>({
    type:actionTypes.TOGGLE_TRANSACTION_ADD_MODAL
})